const VARIANTS = window.VARIANTS;

function bindVariantSelect() {
  const variantSelect = document.getElementById('VariantSelect');

  if (variantSelect) {
    variantSelect.addEventListener('change', (e) => {
      const newId = e.target.value;

      const newUrl = new URL(window.location.href);
      newUrl.searchParams.set('variant', newId);
      window.history.replaceState({}, '', newUrl);

      fetch(`${window.location.pathname}?variant=${newId}&section_id=product`)
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          document.querySelector('#ProductInfo').innerHTML = doc.querySelector('#ProductInfo').innerHTML;
          document.querySelector('#ProductPrice').innerHTML = doc.querySelector('#ProductPrice').innerHTML;
          document.querySelector('#VariantForm').innerHTML = doc.querySelector('#VariantForm').innerHTML;

          bindVariantSelect();
        });
    });
  }
}

document.addEventListener('DOMContentLoaded', bindVariantSelect);
